import { render } from "./ModalBoxInfo.vue?vue&type=template&id=e08c5c48&scoped=true"
import script from "./ModalBoxInfo.vue?vue&type=script&lang=js"
export * from "./ModalBoxInfo.vue?vue&type=script&lang=js"

import "./ModalBoxInfo.vue?vue&type=style&index=0&id=e08c5c48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08c5c48"]])

export default __exports__